import FindJobMatches from './FindJobMatches';

export default {
  list: FindJobMatches,
};
